'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';
import { trackBookingIntent, trackCTAClick } from '@/lib/analytics';

export default function FinalCTA() {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const handleDiagnosisClick = () => {
    trackBookingIntent('homepage-cta');
    trackCTAClick('Start Online Diagnosis', 'homepage-final-cta');
  };

  return (
    <section className="py-16 lg:py-24 bg-surface">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="bg-card rounded-2xl shadow-elevated overflow-hidden">
            <div className="grid grid-cols-1 lg:grid-cols-2">
              <div className="p-8 lg:p-12 bg-primary text-white">
                <h2 className="text-3xl lg:text-4xl font-bold mb-6">
                  Začněte ještě dnes
                </h2>
                <p className="text-lg text-white/90 mb-8 leading-relaxed">
                  Vyplňte online diagnózu a získejte jasný přehled o své finanční situaci. Bez závazků, bez tlaku.
                </p>

                <div className="space-y-4 mb-8">
                  <div className="flex items-start space-x-3">
                    <Icon name="CheckCircleIcon" size={24} className="text-accent flex-shrink-0" variant="solid" />
                    <p className="text-white/90">Rychlý dotazník (5 minut)</p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <Icon name="CheckCircleIcon" size={24} className="text-accent flex-shrink-0" variant="solid" />
                    <p className="text-white/90">Okamžitý přehled vaší situace</p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <Icon name="CheckCircleIcon" size={24} className="text-accent flex-shrink-0" variant="solid" />
                    <p className="text-white/90">Příprava na první schůzku</p>
                  </div>
                </div>

                <Link
                  href="/booking"
                  onClick={handleDiagnosisClick}
                  className="inline-flex items-center space-x-2 px-8 py-4 bg-accent text-accent-foreground font-semibold rounded-lg hover:bg-accent/90 hover:shadow-hover hover:scale-105 transition-smooth">

                  <span>Získat finanční plán
                  </span>
                  <Icon name="ArrowRightIcon" size={20} className="text-current" />
                </Link>
              </div>

              <div className="p-8 lg:p-12 bg-surface">
                <h3 className="text-2xl font-bold text-text-primary mb-6">
                  Nebo nás kontaktujte přímo
                </h3>

                <div className="space-y-6">
                  <div className="flex items-start space-x-4">
                    <div className="flex-shrink-0 w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
                      <Icon name="PhoneIcon" size={24} className="text-primary" />
                    </div>
                    <div>
                      <p className="font-semibold text-text-primary mb-1">Telefon</p>
                      <a href="tel:+420123456789" className="text-text-secondary hover:text-primary transition-smooth">+420 603 349 664

                      </a>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <div className="flex-shrink-0 w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
                      <Icon name="EnvelopeIcon" size={24} className="text-primary" />
                    </div>
                    <div>
                      <p className="font-semibold text-text-primary mb-1">Email</p>
                      <a href="mailto:info@co-work.cz" className="text-text-secondary hover:text-primary transition-smooth">
                        info@co-work.cz
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start space-x-4">
                    <div className="flex-shrink-0 w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
                      <Icon name="MapPinIcon" size={24} className="text-primary" />
                    </div>
                    <div>
                      <p className="font-semibold text-text-primary mb-1">Kancelář</p>
                      <p className="text-text-secondary">
                        Praha-Chodov<br />
                        Osobní i online schůzky
                      </p>
                    </div>
                  </div>

                  <div className="pt-6 border-t border-border">
                    <p className="text-sm text-text-secondary mb-4">
                      Otevírací doba: Po-Pá 9:00-18:00
                    </p>
                    <Link href="/how-we-work"
                    className="inline-flex items-center space-x-2 text-primary hover:text-primary/80 font-medium transition-smooth">

                      <span>Zjistit více o procesu</span>
                      <Icon name="ArrowRightIcon" size={16} className="text-current" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-12 text-center">
            <p className="text-text-secondary mb-4">
              Máte otázky? Podívejte se na naše často kladené otázky
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4">
              <Link
                href="/financial-plan"
                className="text-primary hover:text-primary/80 font-medium transition-smooth">

                Finanční plán
              </Link>
              <span className="text-border">•</span>
              <Link
                href="/first-meeting-analysis"
                className="text-primary hover:text-primary/80 font-medium transition-smooth">

                První schůzka
              </Link>
              <span className="text-border">•</span>
              <Link
                href="/service-long-term-partnership"
                className="text-primary hover:text-primary/80 font-medium transition-smooth">

                Dlouhodobá spolupráce
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>);

}